import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-popup-confirmation',
  templateUrl: './popup-confirmation.component.html',
  styleUrls: ['./popup-confirmation.component.css'],
})
export class PopupConfirmationComponent implements OnInit {
  confirmationMassage: string;
  yesBtnName: string = 'Yes';
  noBtnName: string = 'No';
  isRoutingSource: boolean = false;

  public onClose: Subject<boolean>;
  subject: Subject<boolean>;

  constructor(public bsModalRef: BsModalRef) {}

  public ngOnInit() {
    this.onClose = new Subject<boolean>();
  }

  sendConfirmation(confirm: boolean) {
    if (this.isRoutingSource) {
      this.bsModalRef.hide();
      this.subject.next(confirm);
      this.subject.complete();
    } else {
      this.bsModalRef.hide();
      this.onClose.next(confirm);
      this.onClose.complete();
    }
  }
}
